function normalizePlainText(value) {
	return String(value || '')
		.replace(/<[^>]+>/g, ' ')
		.replace(/\s+/g, ' ')
		.trim()
}

export function resolveAnchor(anchor, content) {
	const a = anchor && typeof anchor === 'object' ? anchor : null
	const baseText = String(a?.text || '').trim()
	if (!baseText) {
		return { status: 'not_found', start: null, end: null, text: null }
	}

	const plain = normalizePlainText(content)
	if (!plain) {
		return { status: 'deleted', start: null, end: null, text: baseText }
	}

	const exactIndex = plain.indexOf(baseText)
	if (exactIndex !== -1) {
		return {
			status: 'active',
			start: exactIndex,
			end: exactIndex + baseText.length,
			text: baseText,
		}
	}

	const contextBefore = String(a?.contextBefore || '')
	const contextAfter = String(a?.contextAfter || '')
	const beforeIndex = contextBefore ? plain.indexOf(contextBefore) : -1
	const afterIndex = contextAfter ? plain.indexOf(contextAfter) : -1
	if (beforeIndex !== -1 && afterIndex !== -1 && beforeIndex < afterIndex) {
		const start = beforeIndex + contextBefore.length
		const end = afterIndex
		if (start < end) {
			return {
				status: 'changed',
				start,
				end,
				text: plain.slice(start, end).trim() || null,
			}
		}
	}

	return { status: 'deleted', start: null, end: null, text: baseText }
}

